const mutations = {

  getOnlineTest: (state, onlinetest) => {
    state.onlinetest = onlinetest;
  },
  getOnlineTestId: (state, onlinetest_id) => {
    state.onlinetest_id = onlinetest_id;
  },
  postOnlineTest: (state, new_onlinetest) => {
    state.onlinetest.push(new_onlinetest);
  },
  putOnlineTest: (state, payload) => {
    state.onlinetest = state.onlinetest.map((onlinetest) => {
      if (onlinetest.id === payload.id) {
        return Object.assign({}, onlinetest, payload.formData);
      }
      return onlinetest;
    });
  },
  delOnlineTest(state, id) {
    const index = state.onlinetest.findIndex(onlinetest => onlinetest.id == id);
    state.onlinetest.splice(index, 1);
  },

};

export default mutations;
